export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement des régions"])},
        "position_connector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sur"])},
        "regions_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["régions"])},
        "view_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])},
        "your_region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["votre région"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regional ranking"])},
        "position_connector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])},
        "regions_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["regions"])},
        "view_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])},
        "your_region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["your region"])}
      }
    }
  })
}
